import styled from '@emotion/styled';
import React from 'react';
import { darken, getContrastRatio } from '@mui/material/styles';
import { bluePlanetTheme } from 'ui/theme';
import { fontSizeSmall } from 'ui/theme/themeBluePlanet';
import { contentSpacing } from 'ui/theme/themeConstants';

export interface RoundedChipProps {
  label: React.ReactNode;
  color?: string;
  className?: string;
}

const StyledChip = styled.div<{ bgColor?: string; clickable?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  color: ${props => {
    const bgColor = props.bgColor || bluePlanetTheme.bluePlanetPalette.purple.medium;
    // Calculate contrast ratio and choose appropriate text color
    const whiteContrast = getContrastRatio(bgColor, bluePlanetTheme.bluePlanetPalette.white);
    const darkContrast = getContrastRatio(bgColor, bluePlanetTheme.bluePlanetPalette.indigo.main);

    // Use white text if it has better contrast, otherwise use dark text
    return whiteContrast > darkContrast
      ? bluePlanetTheme.bluePlanetPalette.white
      : bluePlanetTheme.bluePlanetPalette.indigo.main;
  }};
  border-radius: ${contentSpacing};
  border: 1px solid ${props => darken(props.bgColor || bluePlanetTheme.bluePlanetPalette.purple.medium, 0.3)};
  background-color: ${props => props.bgColor || bluePlanetTheme.bluePlanetPalette.purple.medium};
  font-size: ${fontSizeSmall};
  line-height: 1;
  font-family: ${bluePlanetTheme.typography.fontFamily};
  white-space: nowrap;
`;

const RoundedChip: React.FC<RoundedChipProps> = ({ label, color, className }) => {
  return (
    <StyledChip bgColor={color} className={className}>
      {label}
    </StyledChip>
  );
};

export default RoundedChip;
